// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","overlay":"Modal_overlay__b+zEz","close":"Modal_close__nnot4"};